import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 20000 });

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get('/products', { params });
  return data;
};
export const fetchProduct = async (id) => {
  const { data } = await api.get(`/products/${id}`);
  return data;
};
export const fetchCategories = async () => {
  const { data } = await api.get('/categories');
  return data;
};
export const fetchBrands = async () => {
  const { data } = await api.get('/brands');
  return data;
};
export const fetchTestimonials = async () => {
  const { data } = await api.get('/testimonials');
  return data;
};
export const submitContact = async (payload) => {
  const { data } = await api.post('/contact', payload);
  return data;
};
export const subscribeNewsletter = async (email) => {
  const { data } = await api.post('/newsletter', { email });
  return data;
};
export const createOrder = async (payload) => {
  const { data } = await api.post('/orders', payload);
  return data;
};

export const createCheckoutSession = async (payload) => {
  const { data } = await api.post('/checkout/session', payload);
  return data;
};
export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

// ---- Admin ----
const ADMIN_KEY_STORAGE = 'fpn_admin_key';
export const getAdminKey = () => localStorage.getItem(ADMIN_KEY_STORAGE);
export const setAdminKey = (k) => localStorage.setItem(ADMIN_KEY_STORAGE, k);
export const clearAdminKey = () => localStorage.removeItem(ADMIN_KEY_STORAGE);

const adminHeaders = () => ({ 'X-Admin-Key': getAdminKey() || '' });

export const adminLogin = async (password) => {
  const { data } = await api.post('/admin/login', { password });
  setAdminKey(data.token);
  return data;
};
export const adminStats = async () => {
  const { data } = await api.get('/admin/stats', { headers: adminHeaders() });
  return data;
};
export const adminOrders = async () => {
  const { data } = await api.get('/admin/orders', { headers: adminHeaders() });
  return data;
};
export const adminUpdateOrder = async (id, status) => {
  const { data } = await api.put(`/admin/orders/${id}`, { status }, { headers: adminHeaders() });
  return data;
};
export const adminContacts = async () => {
  const { data } = await api.get('/admin/contact-messages', { headers: adminHeaders() });
  return data;
};
export const adminNewsletter = async () => {
  const { data } = await api.get('/admin/newsletter', { headers: adminHeaders() });
  return data;
};
export const adminCreateProduct = async (payload) => {
  const { data } = await api.post('/admin/products', payload, { headers: adminHeaders() });
  return data;
};
export const adminUpdateProduct = async (id, payload) => {
  const { data } = await api.put(`/admin/products/${id}`, payload, { headers: adminHeaders() });
  return data;
};
export const adminDeleteProduct = async (id) => {
  const { data } = await api.delete(`/admin/products/${id}`, { headers: adminHeaders() });
  return data;
};

export default api;
